"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _useMatchMedia = _interopRequireDefault(require("./use-match-media"));
var _default = _useMatchMedia["default"];
exports["default"] = _default;